import { classes, IconsDetailsStyles } from './style'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import Icon from '@mui/material/Icon'

const initialDetails = [
  { name: 'rooms', value: '', icon: 'bed' },
  { name: 'bathroom', value: '', icon: 'shower' },
  { name: 'toilette', value: '', icon: 'wc' },
  { name: 'stateRank', value: '', icon: 'trending_up' }
]

// eslint-disable-next-line react/prop-types
const IconsDetails = ({ unit }) => {
  return (
    <IconsDetailsStyles className={classes.root}>
      {initialDetails.map((detail, j) => {
        return (
          <Typography variant="caption" fontWeight="bold" className={classes.itemListDetail} key={j} component="span">
            <Tooltip title={detail.name} placement="top">
              <Icon color="primary" fontSize="small" className={classes.icon}>{detail.icon}</Icon>
            </Tooltip>
            {unit[detail.name]}
          </Typography>
        )
      })}
    </IconsDetailsStyles>
  )
}

export default IconsDetails
